import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const MaritimeOperationalRiskManagement = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="MaritimeOperationalRiskManagement" />
                    <HerosectionsAll ScreenName="Maritime Operational Risk Management" ScreenSearch="MaritimeOperationalRiskManagement" />

                    <div className="row col-lg-11 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 p-4 faint" style={{ textAlign: 'justify', }}>
                            <h5 className="fw-bold pb-3 gray_color">Maritime Operational Risk Management </h5>

                            <ul className="ps-4">
                                <li>
                                    We assist shipowners, cargo interests (shippers, receivers, etc.) and charterers in preparing letters of Fair Presentation of Risk based on the risk exposure of the asset to be insured, to enable insurers to rate the proposed risk and quote the premium.
                                </li>
                                <li>
                                    We help clients develop risk control measures by reducing risk through loss prevention and minimization. These are best incorporated in the existing management systems to make them effective.
                                </li>
                                <li>
                                    We provide advice on risk transfer options between various contracts, such as contracts of employment, charter, salvage, towage, general average, etc., and the relevant insurance contracts to avoid gaps and overlaps.
                                </li>
                                <li>
                                    We conduct Risk Management audits to establish the efficacy of existing systems by analysing losses that could have been avoided.
                                </li>
                                <li>
                                    We assist top management with periodic risk reviews, including risk communication, root cause analysis, and corrective and preventive actions.
                                </li>
                            </ul>
                        </div>



                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
